import React from 'react';
import axios from 'axios';
import { Button, Message } from '@alifd/next';
import { Upload } from 'antd';

const UploadExcel: React.FC<{
  setTrigger: React.Dispatch<React.SetStateAction<Record<string, never>>>;
}> = ({ setTrigger }) => {
  return (
    <Upload
      showUploadList={false}
      accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
      customRequest={async (options) => {
        const uploadExcelFile = options.file;
        const formData = new FormData();
        formData.append('files', uploadExcelFile);
        try {
          await axios.post(
            `/ezcon/api/${'updateMaintenanceManagementEquipmentInventory'}`,
            formData,
            {
              headers: {
                authorization: window.localStorage['feathers-jwt'],
              },
            }
          );
          Message.success('上傳成功');
          setTrigger({});
        } catch (error) {
          console.error(error);
          Message.error('上傳失敗');
        }
      }}
    >
      <Button>匯入Excel</Button>
    </Upload>
  );
};

export default UploadExcel;
